import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../api';
import LOGO from '../assets/logo.png';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleForgot = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) return toast.error('Passwords do not match');
    if (newPassword.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, new_password: newPassword });
      toast.success('Password reset successfully! Please log in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed. Link may have expired.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={LOGO} alt="OMIYE MFB" style={{ width: 90 }} />
        </div>
        <div className="login-title">OMIYE MFB HelpDesk</div>

        {token ? (
          // Reset password form
          <>
            <div className="login-sub">Set your new password</div>
            <form onSubmit={handleReset}>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <div style={{ position: 'relative' }}>
                  <input className="form-input" type={showPw ? 'text' : 'password'}
                    style={{ paddingRight: 40 }} placeholder="Min 6 characters"
                    value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
                  <span onClick={() => setShowPw(!showPw)} style={{
                    position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                    cursor: 'pointer', fontSize: 16, color: 'var(--muted)'
                  }}>{showPw ? '🙈' : '👁️'}</span>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Confirm New Password</label>
                <input className="form-input" type="password"
                  placeholder="Re-enter new password"
                  value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
              </div>
              <button className="btn btn-primary login-btn" type="submit" disabled={loading}>
                {loading ? 'Resetting…' : '🔐 Reset Password'}
              </button>
            </form>
          </>
        ) : sent ? (
          // Success state
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>📧</div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Check Your Email</div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20, lineHeight: 1.6 }}>
              If <strong>{email}</strong> is registered, a password reset link has been sent. Check your inbox and spam folder.
            </div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 16 }}>
              The link expires in <strong>1 hour</strong>.
            </div>
            <button className="btn btn-ghost" style={{ width: '100%' }} onClick={() => navigate('/login')}>
              ← Back to Login
            </button>
          </div>
        ) : (
          // Forgot password form
          <>
            <div className="login-sub">Enter your email to receive a reset link</div>
            <form onSubmit={handleForgot}>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input className="form-input" type="email"
                  placeholder="yourname@omiyemfb.com"
                  value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              <button className="btn btn-primary login-btn" type="submit" disabled={loading}>
                {loading ? 'Sending…' : '📧 Send Reset Link'}
              </button>
            </form>
            <button className="btn btn-ghost" style={{ width: '100%', marginTop: 10 }}
              onClick={() => navigate('/login')}>
              ← Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
